import { domain } from "../../domain";

export {
    mainCategory
}

function mainCategory(type=null,per_page=null,page=null,id=null,name=null,orderBy=null){
    if(id){
        return `${domain}/get-main-category?id=${id}`;
    } else if(name){
        return `${domain}/get-main-category?per_page=${per_page}&page=${page}&name=${name}&orderBy=${orderBy}&type=${type}`
    } else {
        return `${domain}/get-main-category?per_page=${per_page}&page=${page}&orderBy=${orderBy}&type=${type}`;
    }
}
